<template>
    <div class="main-wrapper no-padding scroll-y custom-scrollbar view-academy-single">

        <academy-segment></academy-segment>

        <div class="inner-padding">

            <slide-x-left-transition :duration="800" :delay="200">
                <div v-if="show" style="position: relative;">
                    <h3>{{ activeBookmark.label }}</h3>
                </div>
            </slide-x-left-transition>

            <slide-x-left-transition :duration="800" :delay="400">
                <div v-if="show" style="position: relative;" class="mt-20">
                    <div v-html="activeBookmark.content" class="rte rte-bookmark"></div>
                </div>
            </slide-x-left-transition>

            <ion-button mode="ios" expand="block" class="mt-10 mb-10" @click="goTo('Academies')">
                <svg class="icon icon-chevron-back-white"><use xlink:href="#icon-chevron-back-white"></use></svg>
                <span style="display: inline-block; vertical-align: middle"><strong>Wyjdź z Akademii</strong></span>
            </ion-button>

        </div>
    </div>
</template>

<script>
    import goTo from '@/mixins/goto';
    import { mapState } from 'vuex';
    import AcademySegment from '@/navs/AcademySegment';

    export default {
        name: 'AcademyBookmark',
        components: { AcademySegment },
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        computed: {
            ...mapState({
                loading: state => state.academies.loading,
                single: state => state.academies.single,
                news: state => state.academies.news,
            }),
            activeBookmark() {
                if(this.single.bookmarks){
                    return this.single.bookmarks.find(x => x.slug === this.$route.params.id);
                }else{
                    return this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_SINGLE_REQUEST', this.$route.params.slug);
                }
            }
        }
    }
</script>